import {
    Box,
    Typography,
    Link,
    useTheme,
    Divider,
    Container
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoEn from '../../../assets/images/header/logo.svg'
import logoRu from '../../../assets/images/header/logoRu.svg'
import youtubeIcon from '../../../assets/images/footer/Youtube.svg'
import telegramIcon from '../../../assets/images/footer/Telegram.svg'
import mailIcon from '../../../assets/images/footer/mail.svg'
import MenuLink from '../ui/MenuLink';

//

const Footer = () => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const logo = i18n.language === 'ru' ? logoRu : logoEn;

    return (
        <Box
            component='footer'
            sx={{
                py: 5,
                px: 1,
                backgroundColor: '#FFFFFF',
                fontFamily: 'Roboto, sans-serif',
                '& .MuiTypography-root': { fontFamily: 'Roboto, sans-serif' }
            }}
        >
            <Container
                maxWidth={false}
                disableGutters
                sx={{
                    maxWidth: '1680px',
                    mx: 'auto',
                    [theme.breakpoints.down(1920)]: { maxWidth: '100%', mx: 0, px: '64px' },
                    [theme.breakpoints.down(1440)]: { px: '32px' },
                    [theme.breakpoints.down(1200)]: { px: '32px' },
                    [theme.breakpoints.down(992)]: { px: '32px' },
                    [theme.breakpoints.down(768)]: { px: '12px' },
                    [theme.breakpoints.down(480)]: { px: '8px' }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: { xs: 3, md: 5 },
                        width: '100%',
                        [theme.breakpoints.down(1200)]: {
                            display: 'grid',
                            gridTemplateColumns: 'minmax(0,1fr) max-content',
                            alignItems: 'flex-start',
                            justifyContent: 'stretch',
                            columnGap: '32px',
                            rowGap: '12px',
                        },
                        [theme.breakpoints.down(768)]: {
                            display: 'flex',
                            flexDirection: 'column',
                        }
                    }}
                >
                    <Box sx={{ cursor: 'pointer', [theme.breakpoints.down(1200)]: { gridColumn: '1 / -1', gridRow: '1', justifySelf: 'center' }, [theme.breakpoints.down(768)]: { width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center' } }}>
                        <img src={logo} alt='Fleep Bot' style={{ height: '40px' }} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'flex-start', [theme.breakpoints.down(1200)]: { gridColumn: '1', gridRow: '2', justifySelf: 'start' } }}>
                        <MenuLink href='https://telegram.me/FleepSupportBot'>
                            {t('Поддержка')}
                        </MenuLink>
                        <MenuLink to='/affiliate'>
                            {t('Партнерская программа')}
                        </MenuLink>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'flex-start', [theme.breakpoints.down(1200)]: { gridColumn: '1', gridRow: '3', justifySelf: 'start' } }}>
                        <MenuLink href='https://blog.fleep.bot/user_agreement'>
                            {t('Пользовательское соглашение')}
                        </MenuLink>
                        <MenuLink href='https://blog.fleep.bot/privacy_policy'>
                            {t('Политика конфиденциальности')}
                        </MenuLink>
                        <MenuLink href='https://blog.fleep.bot/offer'>
                            {t('Оферта')}
                        </MenuLink>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'flex-start', [theme.breakpoints.down(1200)]: { gridColumn: '2', gridRow: '2 / span 2', justifySelf: 'end' } }}>
                        <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#171718' }}>{t('Мы в соц.сетях')}</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Link component={RouterLink} to='https://www.youtube.com/@FleepBotChannel' aria-label='YouTube' sx={{ color: 'inherit' }}>
                                <img src={youtubeIcon} alt='YouTube' style={{ width: 28, height: 28, display: 'block' }} />
                            </Link>
                            <Link component={RouterLink} to='https://telegram.me/FleepBot' aria-label='Telegram' sx={{ color: 'inherit' }}>
                                <img src={telegramIcon} alt='Telegram' style={{ width: 28, height: 28, display: 'block' }} />
                            </Link>
                        </Box>
                        <MenuLink
                            href='mailto:support@fleep.bot'
                            icon={
                                <Box
                                    component='span'
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        bgcolor: 'currentColor',
                                        WebkitMaskImage: `url(${mailIcon})`,
                                        WebkitMaskRepeat: 'no-repeat',
                                        WebkitMaskPosition: 'center',
                                        WebkitMaskSize: 'contain',
                                        maskImage: `url(${mailIcon})`,
                                        maskRepeat: 'no-repeat',
                                        maskPosition: 'center',
                                        maskSize: 'contain',
                                    }}
                                />
                            }
                        >
                            support@fleep.bot
                        </MenuLink>
                    </Box>
                </Box>
                <Divider sx={{ my: 3, borderColor: '#F3F3F3' }} />
                <Typography align='center' sx={{ fontSize: '16px', color: '#555559' }}>
                    © FleepBot, 2018-2025
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
